export const GRIDS_LOCALSTORAGE_KEY = "rlviz/grids";
